import { sprintf } from "sprintf-js"

export default function(time, precision) {
  let minutes = Math.floor(time / 60)
  let seconds = time - (minutes * 60)

  if ( seconds == parseInt(seconds) ) {
    return sprintf("%d:%02d", minutes, seconds)
  } else {
    if ( precision == undefined )
      precision = 2

    const totalDigits = 2 + (precision > 0 ? precision + 1 : 0)
    return sprintf(`%d:%0${totalDigits}.${precision}f`, minutes, seconds)
  }
}

// Inverse of timeFormat: converts "M:SS" or "MM:SS" format to seconds (floating point)
// Returns tuple: [time, error] where error is null if valid
export function parseTimeText(timeText) {
  if (!timeText || typeof timeText !== 'string') {
    return [0, 'Time is required']
  }

  const parts = timeText.split(':')
  if (parts.length !== 2) {
    return [0, 'Invalid time format. Use M:SS or MM:SS (e.g., 3:45)']
  }

  const minutes = parseFloat(parts[0])
  const seconds = parseFloat(parts[1])

  if (isNaN(minutes) || isNaN(seconds)) {
    return [0, 'Invalid time format. Minutes and seconds must be numbers']
  }

  if (minutes < 0 || seconds < 0 || seconds >= 60) {
    return [0, 'Invalid time. Seconds must be between 0 and 59']
  }

  return [minutes * 60 + seconds, null]
}
